"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _component = _interopRequireDefault(require("./component"));
var _sandbox = _interopRequireDefault(require("./sandbox"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StandaloneApp = exports.default = /*#__PURE__*/function (_React$Component) {
  function StandaloneApp(props) {
    var _this;
    (0, _classCallCheck2.default)(this, StandaloneApp);
    _this = _callSuper(this, StandaloneApp, [props]);

    // eslint-disable-next-line react/state-in-constructor
    (0, _defineProperty2.default)(_this, "handleChange", function (notebookState) {
      var afterChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      _this.setState({
        notebookState: _objectSpread(_objectSpread({}, notebookState), {}, {
          isExecuted: false
        })
      }, function () {
        _this.props.onChange(_this.state.notebookState);
        afterChange(_this.state.notebookState);
      });
    });
    (0, _defineProperty2.default)(_this, "handleExecute", function () {
      var notebookState = _this.state.notebookState;
      var _this$props = _this.props,
        blockNumber = _this$props.blockNumber,
        sandbox = _this$props.sandbox,
        beforeExecute = _this$props.beforeExecute;
      _this.handleChange(_objectSpread(_objectSpread({}, notebookState), {}, {
        isLoading: true
      }));
      return beforeExecute(notebookState).then(function () {
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            sandbox.execute(notebookState.content, blockNumber).then(function (exec) {
              _this.handleChange(_objectSpread(_objectSpread({}, notebookState), {}, {
                exec: exec,
                isLoading: false
              }), function (newNotebookState) {
                _this.setState({
                  notebookState: _objectSpread(_objectSpread({}, newNotebookState), {}, {
                    isExecuted: true
                  })
                });
              });
            }).then(resolve).catch(reject);
          }, 1);
        });
      });
    });
    _this.state = {
      notebookState: {
        content: _this.props.content
      }
    };
    return _this;
  }
  (0, _inherits2.default)(StandaloneApp, _React$Component);
  return (0, _createClass2.default)(StandaloneApp, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        blockNumber = _this$props2.blockNumber,
        sandbox = _this$props2.sandbox,
        ramlClientConfig = _this$props2.ramlClientConfig,
        workerPath = _this$props2.workerPath;
      var notebookState = this.state.notebookState;
      return /*#__PURE__*/_react.default.createElement(_component.default, {
        workerPath: workerPath,
        blockNumber: blockNumber,
        notebookState: notebookState,
        onChange: this.handleChange,
        onExecute: this.handleExecute,
        sandbox: sandbox,
        ramlClientConfig: ramlClientConfig
      });
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(StandaloneApp, "propTypes", {
  content: _propTypes.default.string,
  workerPath: _propTypes.default.string,
  blockNumber: _propTypes.default.number,
  sandbox: _propTypes.default.object,
  onChange: _propTypes.default.func,
  beforeExecute: _propTypes.default.func,
  ramlClientConfig: _propTypes.default.object
});
(0, _defineProperty2.default)(StandaloneApp, "defaultProps", {
  content: '',
  workerPath: '/worker.js',
  blockNumber: 0,
  sandbox: new _sandbox.default(),
  onChange: function onChange() {},
  beforeExecute: function beforeExecute() {
    return Promise.resolve();
  }
});
//# sourceMappingURL=standalone.js.map